import baseDomain,{ printMediaAssest } from '../../../assets/images/imageAsset'

const printMedia = [
  {
    year: 'archives',
    media: [
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest1}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest2}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest3}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest4}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest5}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest6}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest7}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest8}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest10}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest11}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest12}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest13}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest14}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest15}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest16}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest17}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest18}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest20}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest21}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest22}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest23}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest24}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest25}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest26}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest27}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest28}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest29}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest30}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest31}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest32}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest33}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest34}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest35}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest36}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest37}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest38}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest39}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest40}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest41}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest42}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest43}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest44}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest45}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest46}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest47}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest48}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest49}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest50}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest51}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest52}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest53}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest54}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest55}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest56}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest57}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest58}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest59}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest60}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest61}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest62}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest63}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest64}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest65}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest66}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest67}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest68}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAsses69}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest70}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest71}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest71}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest73}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest74}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest75}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest76}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest77}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest78}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest79}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest80}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest81}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest82}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest83}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest84}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest85}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest86}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest87}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest88}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest89}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest90}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest91}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest92}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest93}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest94}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest95}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest96}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest97}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest98}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest99}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest100}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest101}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest102}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest103}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest104}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest105}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest106}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest107}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest108}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest109}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest110}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest111}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest112}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest113}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest114}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest115}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest116}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest117}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest118}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest119}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest120}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest121}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest122}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest123}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest124}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest125}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest126}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest127}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest128}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest130}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest131}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest132}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest133}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest134}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest135}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest136}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest137}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest138}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest140}`,
        url: '',
        alt: 'NEWSPAPER ARCHIVES',
      }
    ],
  },
  {
    year: '2014',
    media : [
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest143}`,
        url:'',
        alt:'NEWSPAPER ARCHIVES'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest144}`,
        url:'',
        alt:'DAINIK DUNIYA'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest145}`,
        url:'',
        alt:'PRAHAAR'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest146}`,
        url:'',
        alt:'PRAHAAR'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest147}`,
        url:'',
        alt:'PRAHAAR'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest148}`,
        url:'',
        alt:'PRAHAAR'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest149}`,
        url:'',
        alt:'PRAHAAR'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest150}`,
        url:'',
        alt:'PRAHAAR'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest151}`,
        url:'',
        alt:'THE TIMES OF INDIA'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest152}`,
        url:'',
        alt:'ABSOLUTE INDIA'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest153}`,
        url:'',
        alt:'ABSOLUTE INDIA'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest154}`,
        url:'',
        alt:'ABSOLUTE INDIA'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest155}`,
        url:'',
        alt:'DNA'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest156}`,
        url:'',
        alt:'MID DAY'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest157}`,
        url:'',
        alt:'PRAHAAR MUMBAI'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest158}`,
        url:'',
        alt:'PRAHAAR MUMBAI'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest159}`,
        url:'',
        alt:'DNA'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest160}`,
        url:'',
        alt:'gujarat samachar'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest161}`,
        url:'',
        alt:'Superwoman Magazine_May 2014'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest162}`,
        url:'',
        alt:'Superwoman Magazine_May 2014'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest163}`,
        url:'',
        alt:'Superwoman Magazine_May 2014'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest164}`,
        url:'',
        alt:'Superwoman Magazine_May 2014'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest165}`,
        url:'',
        alt:'Superwoman Magazine_May 2014'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest166}`,
        url:'',
        alt:'Superwoman Magazine_May 2014'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest167}`,
        url:'',
        alt:'Superwoman Magazine_May 2014'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest168}`,
        url:'',
        alt:'The Times of India_June2014'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest169}`,
        url:'',
        alt:'The Times of India_June2014'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest170}`,
        url:'',
        alt:'THE TIMES OF INDIA'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest171}`,
        url:'',
        alt:'Afternoon_14th Aug 2014'
      }
     
    ]
  },
  {
    year:'2015',
    media:[
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest172}`,
        url:'',
        alt:'Navbharat Times Mumbai_June 2015'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest173}`,
        url:'',
        alt:'Navbharat Times_June 2015'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest174}`,
        url:'',
        alt:'Navbharat Times_June 2015'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest175}`,
        url:'',
        alt:'Chitralekha Gujarati Magazine_June 2015'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest176}`,
        url:'',
        alt:'Chitralekha Gujarati Magazine_June 2015'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest177}`,
        url:'',
        alt:'Chitralekha Gujarati Magazine_June 2015'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest178}`,
        url:'',
        alt:'Chitralekha Gujarati Magazine_June 2015'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest179}`,
        url:'',
        alt:'DNA_June 2015'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest180}`,
        url:'',
        alt:'DNA_June 2015'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest181}`,
        url:'',
        alt:'DNA_June 2015'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest182}`,
        url:'',
        alt:'DNA_June 2015'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest183}`,
        url:'',
        alt:'Hindustan Times_June 2015'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest184}`,
        url:'',
        alt:'Liveminit_June 2015'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest185}`,
        url:'',
        alt:'Mahanagar_June 2015'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest186}`,
        url:'',
        alt:'Mahanagar_June 2015'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest187}`,
        url:'',
        alt:'The Times of India_June 2015'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest188}`,
        url:'',
        alt:'Mumbai Navbharat Times_June 2015'
      }
      
    ]
  },
  {
    year:'2016',
    media:[
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest189}`,
        url:'',
        alt:'navbharat-times_august-29'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest190}`,
        url:'',
        alt:'Lokmat (Hello Mumbai)_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest191}`,
        url:'',
        alt:'Absolute India (Hindi)_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest192}`,
        url:'',
        alt:'haribhoomi-_august-2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest193}`,
        url:'',
        alt:'Navrashtra (Mumbai Pluse)_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest194}`,
        url:'',
        alt:'Janmabhoomi_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest195}`,
        url:'',
        alt:'Punya Nagari (Smart Mumbai)_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest196}`,
        url:'',
        alt:'Active Times_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest197}`,
        url:'',
        alt:'Divya Bhaskar_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest198}`,
        url:'',
        alt:'Dopahar Ka Saamana_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest199}`,
        url:'',
        alt:'Hamara Mahanagar_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest200}`,
        url:'',
        alt:'Mahasagar_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest201}`,
        url:'',
        alt:'Mumbai Lakshdeep_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest202}`,
        url:'',
        alt:'Loknayak_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest203}`,
        url:'',
        alt:'Navbharat_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest204}`,
        url:'',
        alt:'Navshakti_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest205}`,
        url:'',
        alt:'Mumbai Choufer_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest206}`,
        url:'',
        alt:'Sakal_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest207}`,
        url:'',
        alt:'Chak de Gujarat_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest208}`,
        url:'',
        alt:'Deshonnati_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest209}`,
        url:'',
        alt:'Dhabkar_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest210}`,
        url:'',
        alt:'Divya Gujarat_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest211}`,
        url:'',
        alt:'Gujarat Pranam_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest212}`,
        url:'',
        alt:'Gujarati Samachar_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest213}`,
        url:'',
        alt:'Hukumnama Samachar_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest214}`,
        url:'',
        alt:'Jansansar_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest215}`,
        url:'',
        alt:'Loktej_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest216}`,
        url:'',
        alt:'Maharashtra Tarun Darpan_Augsut 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest217}`,
        url:'',
        alt:'Navgujarat Times_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest218}`,
        url:'',
        alt:'Yugdharma_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest219}`,
        url:'',
        alt:'Rashtradoot_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest220}`,
        url:'',
        alt:'Rashtrapraksh_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest221}`,
        url:'',
        alt:'Saamana Times_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest222}`,
        url:'',
        alt:'Virat Vaibha_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest223}`,
        url:'',
        alt:'Samachar Ki Dunia_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest224}`,
        url:'',
        alt:'Sushila Times_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest225}`,
        url:'',
        alt:'Samana Dainik_August 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest226}`,
        url:'',
        alt:'LOKMAT_JUNE 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest227}`,
        url:'',
        alt:'Dopahar Ka Saamna_June 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest228}`,
        url:'',
        alt:'Janmabhoomi_June 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest229}`,
        url:'',
        alt:'MID-DAY_JUNE 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest230}`,
        url:'',
        alt:'NAVSHAKTI_JUNE 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest231}`,
        url:'',
        alt:'LOKMAT (HALLO MUMBAI)_JUNE 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest232}`,
        url:'',
        alt:'LOKMAT (HALLO MUMBAI)_JUNE 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest233}`,
        url:'',
        alt:'Mumbai Tarun Bharat_June 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest234}`,
        url:'',
        alt:'MID-DAY_JUNE 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest235}`,
        url:'',
        alt:'Tarun Bharat_June 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest236}`,
        url:'',
        alt:'Maharashtra Times_June 2016'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest237}`,
        url:'',
        alt:'The Asian Age (Mumbai Age)_JUNE 2016'
      }
      
    ]
  },
  {
    year:'2017',
    media:[
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest238}`,
        url:'',
        alt:'Mumbai Mirror'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest239}`,
        url:'',
        alt:'Mumbai Mirror'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest240}`,
        url:'',
        alt:'THE ASIAN AGE'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest241}`,
        url:'',
        alt:'DNA'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest242}`,
        url:'',
        alt:'Press information Bureau'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest243}`,
        url:'',
        alt:'Hindustantimes'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest244}`,
        url:'',
        alt:'Navshakti'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest245}`,
        url:'',
        alt:'ABSOLUTE INDIA'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest246}`,
        url:'',
        alt:'Lokmat'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest247}`,
        url:'',
        alt:'Press information Bureau'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest248}`,
        url:'',
        alt:'Asian lite'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest249}`,
        url:'',
        alt:'Dabang Dunia'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest250}`,
        url:'',
        alt:'Press information Bureau'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest251}`,
        url:'',
        alt:'Punyanagari'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest252}`,
        url:'',
        alt:'Press information Bureau'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest253}`,
        url:'',
        alt:'Press information Bureau'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest254}`,
        url:'',
        alt:'DD NEWS'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest255}`,
        url:'',
        alt:'Current affairs.adda247.com'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest256}`,
        url:'',
        alt:'The Asian Age'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest257}`,
        url:'',
        alt:'Lokmat Samachar'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest258}`,
        url:'',
        alt:'The Asian Age_Hrishiji'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest259}`,
        url:'',
        alt:'Indiaonline in News'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest260}`,
        url:'',
        alt:'Skala'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest261}`,
        url:'',
        alt:'The Hindu'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest262}`,
        url:'',
        alt:'Hamara Mahanagar'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest263}`,
        url:'',
        alt:'Gujarat Samachar'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest264}`,
        url:'',
        alt:'Janshakti'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest265}`,
        url:'',
        alt:'Mumbai Samachar'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest266}`,
        url:'',
        alt:'Indian Express'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest267}`,
        url:'',
        alt:'Press information Bureau'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest268}`,
        url:'',
        alt:'The Hindu'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest269}`,
        url:'',
        alt:'NDTV'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest270}`,
        url:'',
        alt:'Pudhari'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest271}`,
        url:'',
        alt:'Press information Bureau'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest272}`,
        url:'',
        alt:'Dainik Bhaskar'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest273}`,
        url:'',
        alt:'United News of India'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest274}`,
        url:'',
        alt:'Yashobhumi 20th November 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest275}`,
        url:'',
        alt:'Loksatta 20th November 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest276}`,
        url:'',
        alt:'Hamara Mahanagar 20th November 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest277}`,
        url:'',
        alt:'Mid-day.com 20th November 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest278}`,
        url:'',
        alt:'Outlook the News scroll 19th November 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest279}`,
        url:'',
        alt:'The Hindu 20th November 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest280}`,
        url:'',
        alt:'INDIA TODAY GROUP 19th November 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest281}`,
        url:'',
        alt:'INDIAN EXPRESS 21st November 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest282}`,
        url:'',
        alt:'Indiatoday 19th November 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest283}`,
        url:'',
        alt:'Navbharat Times'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest284}`,
        url:'',
        alt:'Divya Bhaskar'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest285}`,
        url:'',
        alt:'Janmabhoomi 21st November 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest286}`,
        url:'',
        alt:'Dopahar'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest287}`,
        url:'',
        alt:'Business Standard 19th November 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest288}`,
        url:'',
        alt:'Janmabhoomi Gujarati'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest289}`,
        url:'',
        alt:'Maharashtra Times'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest290}`,
        url:'',
        alt:'The Indian Express'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest291}`,
        url:'',
        alt:'ET Healthworld 20th November 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest292}`,
        url:'',
        alt:'Janmabhoomi Gujarati'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest293}`,
        url:'',
        alt:'Navbharat times 5th December 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest294}`,
        url:'',
        alt:'Navbharat times 4th December 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest295}`,
        url:'',
        alt:'Navbharat times 3rd December 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest296}`,
        url:'',
        alt:'Navbharat times 1st December 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest297}`,
        url:'',
        alt:'Navbharat times 30th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest298}`,
        url:'',
        alt:'Navbharat times 28th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest299}`,
        url:'',
        alt:'Navbharat times 28th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest300}`,
        url:'',
        alt:'Navbharat times 27th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest301}`,
        url:'',
        alt:'Navbharat times 26th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest302}`,
        url:'',
        alt:'Navbharat times 24th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest303}`,
        url:'',
        alt:'Navbharat times 23rd Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest304}`,
        url:'',
        alt:'Navbharat times 21th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest305}`,
        url:'',
        alt:'Navbharat times 20th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest306}`,
        url:'',
        alt:'Navbharat times 18th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest307}`,
        url:'',
        alt:'Navbharat times 17th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest308}`,
        url:'',
        alt:'Navbharat times 16th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest309}`,
        url:'',
        alt:'Navbharat times 14th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest310}`,
        url:'',
        alt:'Navbharat times 13th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest311}`,
        url:'',
        alt:'Navbharat times 10th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest312}`,
        url:'',
        alt:'Navbharat times 9th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest313}`,
        url:'',
        alt:'Navbharat times 7th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest314}`,
        url:'',
        alt:'Navbharat times 6th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest315}`,
        url:'',
        alt:'Navbharat times 5th Nov 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest316}`,
        url:'',
        alt:'Navbharat Times Mumbai 18th June 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest317}`,
        url:'',
        alt:'Navbharat Times Mumbai 10th May 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest318}`,
        url:'',
        alt:'Aaj ki taza khabar 30th April 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest319}`,
        url:'',
        alt:'Dailyworld 30th April 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest320}`,
        url:'',
        alt:'Financial Express 30th April 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest321}`,
        url:'',
        alt:'Indiatoday 30th April 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest322}`,
        url:'',
        alt:'Inshorts Press Trust of India 30th April 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest323}`,
        url:'',
        alt:'One News Page 30th April 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest324}`,
        url:'',
        alt:'Oneindia 30th April 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest325}`,
        url:'',
        alt:'Outlook The News Scroll 30th April 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest326}`,
        url:'',
        alt:'People magazines 1st May 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest327}`,
        url:'',
        alt:'The Indian Express 1 May 2017'
      },{
        img: `${baseDomain}${printMediaAssest.printMediaAssest328}`,
        url:'',
        alt:'UgoSay 30th April 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest329}`,
        url:'',
        alt:'UgoSay 30th April 2017'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest330}`,
        url:'',
        alt:'The Times of India, Mumbai 12th April 2017'
      }
      
    ]
  },
  {
    year:'2018',
    media:[
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest331}`,
        url:'',
        alt:'Lucknow News_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest332}`,
        url:'',
        alt:'Sabhi Samanta_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest333}`,
        url:'',
        alt:'Pratidin Rajdhani_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest334}`,
        url:'',
        alt:'Spasht Awaz_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest335}`,
        url:'',
        alt:'Spasht Awaz_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest336}`,
        url:'',
        alt:'Herald Young Leader_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest337}`,
        url:'',
        alt:'Uttar Bharat Live_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest338}`,
        url:'',
        alt:'Aaj Lucknow_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest339}`,
        url:'',
        alt:'Aaj_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest340}`,
        url:'',
        alt:'Veer Arjun_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest341}`,
        url:'',
        alt:'Swatantra Bharat_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest342}`,
        url:'',
        alt:'Sach Ka Ujala_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest343}`,
        url:'',
        alt:'Rakhewal_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest344}`,
        url:'',
        alt:'Gujarat Pranam_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest345}`,
        url:'',
        alt:'Future Kerala_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest346}`,
        url:'',
        alt:'Divya Gujarati_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest347}`,
        url:'',
        alt:'Hari Bhoomi_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest348}`,
        url:'',
        alt:'Suryakaal_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest349}`,
        url:'',
        alt:'Allahabad Express_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest350}`,
        url:'',
        alt:'Rashtra Chinatk_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest351}`,
        url:'',
        alt:'Jansandesh Times_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest352}`,
        url:'',
        alt:'Daily News & Analysis_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest353}`,
        url:'',
        alt:'BPN Times_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest354}`,
        url:'',
        alt:'Amrit Sandesh_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest355}`,
        url:'',
        alt:'Central Chronicle_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest356}`,
        url:'',
        alt:'Pioneer_31st December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest357}`,
        url:'',
        alt:'Janseva Mail_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest358}`,
        url:'',
        alt:'Action India_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest359}`,
        url:'',
        alt:'Hindustan Times_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest360}`,
        url:'',
        alt:'Khusro mail_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest361}`,
        url:'',
        alt:'ANG Bharat_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest362}`,
        url:'',
        alt:'Morning India_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest363}`,
        url:'',
        alt:'Khabar Mantra_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest364}`,
        url:'',
        alt:'Repoter Post_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest365}`,
        url:'',
        alt:'Loksatya_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest366}`,
        url:'',
        alt:'Son Bhadra Express_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest367}`,
        url:'',
        alt:'Jagat Kranti _30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest368}`,
        url:'',
        alt:'Divya Prakash_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest369}`,
        url:'',
        alt:'Samay Jagat_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest370}`,
        url:'',
        alt:'Shah Times_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest371}`,
        url:'',
        alt:'Sudarshan Express_31st December 2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest372}`,
        url:'',
        alt:'Rashtriya Sahara_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest373}`,
        url:'',
        alt:'Pushp Savera_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest374}`,
        url:'',
        alt:'The Avenue Mail_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest375}`,
        url:'',
        alt:'Shivpuri Ki Awaz_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest376}`,
        url:'',
        alt:'Sea Express_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest377}`,
        url:'',
        alt:'Amrit Varsha_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest378}`,
        url:'',
        alt:'Shakti Times_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest379}`,
        url:'',
        alt:'Shakti Times_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest380}`,
        url:'',
        alt:'Nisha Naresh_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest381}`,
        url:'',
        alt:'Doon Darpan_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest382}`,
        url:'',
        alt:'Shekhar Times_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest383}`,
        url:'',
        alt:'Gurgaon Mail_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest384}`,
        url:'',
        alt:'Swarajya Times_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest385}`,
        url:'',
        alt:'The Himachal Times_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest386}`,
        url:'',
        alt:'Son Varsha Vani_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest387}`,
        url:'',
        alt:'Media Darshan_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest388}`,
        url:'',
        alt:'Navbharat Times_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest389}`,
        url:'',
        alt:'Sanmarg_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest390}`,
        url:'',
        alt:'Tasvire Bharat_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest391}`,
        url:'',
        alt:'Yuvahastakshar_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest392}`,
        url:'',
        alt:'Rashtriya Swaroop_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest393}`,
        url:'',
        alt:'Janta Union_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest394}`,
        url:'',
        alt:'Dopahar ka Saamana_29th Dec 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest395}`,
        url:'',
        alt:'Aapla Mahanagar_29 Dec 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest396}`,
        url:'',
        alt:'Hindustan Times_29th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest397}`,
        url:'',
        alt:'Lokmat_29th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest398}`,
        url:'',
        alt:'Hamara Mahanagar_29th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest399}`,
        url:'',
        alt:'Dabang Dunia_29th Dec 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest400}`,
        url:'',
        alt:'Do Baje Dophar_29th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest401}`,
        url:'',
        alt:'EENADU INDIA_26th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest402}`,
        url:'',
        alt:'Economic Times_26th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest403}`,
        url:'',
        alt:'Business Standard_19th Dec 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest404}`,
        url:'',
        alt:'Business Standard_19th Dec 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest405}`,
        url:'',
        alt:'Deccan Herald _19th Dec 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest406}`,
        url:'',
        alt:'divya bhaskar'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest407}`,
        url:'',
        alt:'Eenadu India _20th June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest408}`,
        url:'',
        alt:'Fab info Fashion and Business 23 March 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest409}`,
        url:'',
        alt:'Good Evening Newspaper Indore_11th Dec 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest410}`,
        url:'',
        alt:'India Today'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest411}`,
        url:'',
        alt:'Front page'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest412}`,
        url:'',
        alt:'KOLHAPUR PRESS'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest413}`,
        url:'',
        alt:'Lokmat_12th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest414}`,
        url:'',
        alt:'Navdunia'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest415}`,
        url:'',
        alt:'The Pioneer_30th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest416}`,
        url:'',
        alt:'Patrika'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest417}`,
        url:'',
        alt:'Pradesh Today'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest418}`,
        url:'',
        alt:'The Times of India Speaking Tree_22nd Dec 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest419}`,
        url:'',
        alt:'Navbharat Times_29th December 2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest420}`,
        url:'',
        alt:'The Hindu_29th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest421}`,
        url:'',
        alt:'Moneycontrol_28th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest422}`,
        url:'',
        alt:'The Week Magazine_28th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest423}`,
        url:'',
        alt:'Mumbai Mirror_26th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest424}`,
        url:'',
        alt:'The Free Press Journal_25th December 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest425}`,
        url:'',
        alt:'The Times of India Speaking Tree_23rd Dec 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest426}`,
        url:'',
        alt:'The Times of India_19th Dec 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest427}`,
        url:'',
        alt:'Prahaar_19th Dec 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest428}`,
        url:'',
        alt:'The Tribune _19th Dec 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest429}`,
        url:'',
        alt:'Latest LY_19th Dec 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest430}`,
        url:'',
        alt:'Dainik Bhaskar_11th Dec 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest431}`,
        url:'',
        alt:'Prabhat Kiran Indore_11th Dec 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest432}`,
        url:'',
        alt:'Dainik Bhaskar_19th Nov 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest433}`,
        url:'',
        alt:'Ghamasan_19th Nov 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest434}`,
        url:'',
        alt:'Indore Samachar_19th Nov 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest435}`,
        url:'',
        alt:'ON TIME NEWS_19th Nov 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest436}`,
        url:'',
        alt:'Raj Express_19th Nov 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest437}`,
        url:'',
        alt:'Dastak_Indore_19th Nov 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest438}`,
        url:'',
        alt:'The Novhind Times_15th October 2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest439}`,
        url:'',
        alt:'Herold'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest440}`,
        url:'',
        alt:'Gomantak Times_13th October 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest441}`,
        url:'',
        alt:'Dabang Dunia _21 June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest442}`,
        url:'',
        alt:'Haribhoomi _22nd June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest443}`,
        url:'',
        alt:'Haribhoomi_22nd June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest445}`,
        url:'',
        alt:'Dainik Jagran_22 June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest446}`,
        url:'',
        alt:'Dainik Bhaskar_22nd June 2018 1'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest447}`,
        url:'',
        alt:'Navbharat Bhopal_22nd June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest448}`,
        url:'',
        alt:'Navbharat_22 June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest449}`,
        url:'',
        alt:'Dainik Bhaskar_22nd June 2018 2'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest450}`,
        url:'',
        alt:'Dainik Bhaskar_22nd June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest451}`,
        url:'',
        alt:'Haribhoomi _22nd June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest452}`,
        url:'',
        alt:'Latestly beta_22nd June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest453}`,
        url:'',
        alt:'Newkerala.com_21st June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest454}`,
        url:'',
        alt:'Peoples samachar_21 June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest456}`,
        url:'',
        alt:'Daily World_20th June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest457}`,
        url:'',
        alt:'Agniban_20th June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest458}`,
        url:'',
        alt:'Haribhoomi'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest459}`,
        url:'',
        alt:'Patrika Bhopal_22nd June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest460}`,
        url:'',
        alt:'Patrika Bhopal_22nd June 2018 1'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest461}`,
        url:'',
        alt:'Dainik Jagran'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest462}`,
        url:'',
        alt:'nerve.in'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest463}`,
        url:'',
        alt:'Raj Express'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest464}`,
        url:'',
        alt:'The Times of India _22 June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest465}`,
        url:'',
        alt:'Lokmat_21st June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest467}`,
        url:'',
        alt:'Divya Bhaskar Gujarati_2 June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest468}`,
        url:'',
        alt:'Times of India_20th June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest469}`,
        url:'',
        alt:'News18_20th June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest470}`,
        url:'',
        alt:'Navbharat Times_15 June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest471}`,
        url:'',
        alt:'Navbharat Times_14 June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest472}`,
        url:'',
        alt:'Navbharat Times_12 June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest473}`,
        url:'',
        alt:'Dophar ka Samna_4 June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest474}`,
        url:'',
        alt:'Navbharat Times_4 June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest475}`,
        url:'',
        alt:'Chitralekha Magazine_June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest476}`,
        url:'',
        alt:'Navbharat Times_5 June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest478}`,
        url:'',
        alt:'Navbharat Times_3 June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest479}`,
        url:'',
        alt:'Janmabhoomi_2 June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest480}`,
        url:'',
        alt:'Janmabhoomi_2 June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest481}`,
        url:'',
        alt:'Chitralekha Magazine_June 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest482}`,
        url:'',
        alt:'Hindustan times mumbai_16th May 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest483}`,
        url:'',
        alt:'Central Chronicle'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest484}`,
        url:'',
        alt:'Samana_7th May 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest485}`,
        url:'',
        alt:'FOREVER NEWS_4th May 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest486}`,
        url:'https://www.apnnews.com/the-yoga-institute-brings-the-100-year-old-heritage-of-classical-yoga-online-on-google-arts-culture/',
        alt:'APN NEWS_7th May 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest487}`,
        url:'',
        alt:'Travel 360 magazine'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest488}`,
        url:'',
        alt:'E-Times_Entertainment news_April 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest489}`,
        url:'',
        alt:'Chitralekha Magazine'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest490}`,
        url:'',
        alt:'Castrol India news press release'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest491}`,
        url:'',
        alt:'Tennews in national news Portal 23 March 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest492}`,
        url:'',
        alt:'Parichya Times 23 March 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest493}`,
        url:'',
        alt:'Deshbandhu 23rd March 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest494}`,
        url:'',
        alt:'Vir Arjun 23 March 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest495}`,
        url:'',
        alt:'Vir Arjun 23 March 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest496}`,
        url:'',
        alt:'Shreeji Express 23 March 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest497}`,
        url:'',
        alt:'Shine Delhi 23 March 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest498}`,
        url:'',
        alt:'News Dastak 23 March 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest499}`,
        url:'',
        alt:'Swatantra Prabhat 23 March 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest500}`,
        url:'',
        alt:'Amar Ujala 23 March 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest501}`,
        url:'',
        alt:'News Harpal 23 March 2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest502}`,
        url:'',
        alt:'Outlook magazine'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest931}`,
        url:'',
        alt:'Bullet Daily News'
      }
    ]
  },
  {
    year:'2019',
    media:[
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest503}`,
        url:'',
        alt:'ABP-maza-live-marathi-News_10th-Jan-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest504}`,
        url:'',
        alt:'Aacharan_5th-January-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest505}`,
        url:'',
        alt:'Biospectrum_14th-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest506}`,
        url:'',
        alt:'Business-remedies_2nd-January-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest507}`,
        url:'https://www.business-standard.com/article/pti-stories/yoga-invaluable-gift-from-india-to-mankind-maha-guv-119122800690_1.html',
        alt:'Bussiness-standard-28th-Dec-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest508}`,
        url:'',
        alt:'DABANG-DUNIA-22nd-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest509}`,
        url:'',
        alt:'DNA_6th-January-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest510}`,
        url:'',
        alt:'Dailyhunt_6th-Jan-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest511}`,
        url:'',
        alt:'Dainik-Bhor_1st-January-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest512}`,
        url:'',
        alt:'Et-Auto.com-from-The-Economic-Times_20th-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest513}`,
        url:'',
        alt:'Express-Healthcare_21st-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest514}`,
        url:'',
        alt:'Flipboard_6th-Jan-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest515}`,
        url:'',
        alt:'Forever-News-21st-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest516}`,
        url:'',
        alt:'Forever-News_25th-July-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest517}`,
        url:'',
        alt:'Future-Kerala_1st-January-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest518}`,
        url:'',
        alt:'GUJARAT-SAMACHAR-22nd-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest519}`,
        url:'http://www.globalnewzservice.com/?p=16757',
        alt:'Global-News-Service_24th-July-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest520}`,
        url:'',
        alt:'Gorakhpur-Mail_1st-January-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest521}`,
        url:'',
        alt:'Gujaratn Samachar_18th-Sept-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest522}`,
        url:'',
        alt:'Hello-Mumbai_12th-December-2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest523}`,
        url:'https://www.herzindagi.com/fitness/for-discipline-mental-health-focus-in-children-try-yoga-for-kids-article-132001',
        alt:'Her--zindagi'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest524}`,
        url:'https://www.herzindagi.com/fitness/yoga-for-people-suffering-with-arthritis-by-expert-article-132701',
        alt:'Her--zindagi'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest525}`,
        url:'https://www.herzindagi.com/hindi/fitness/how-yoga-reduces-joint-pain-and-swelling-in-winter-according-to-expert-article-135541?WA',
        alt:'Her--zindagi'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest526}`,
        url:'',
        alt:'Hindmata-Prime-News_24th-July-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest527}`,
        url:'',
        alt:'Hindustan-Express_31st-January-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest528}`,
        url:'',
        alt:'I-Next_2nd-January-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest529}`,
        url:'',
        alt:'Indian television_20th-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest530}`,
        url:'',
        alt:'JANMABHOOMI-22nd-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest531}`,
        url:'',
        alt:'Janmabhoomi_18th-December-2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest532}`,
        url:'',
        alt:'Jeevan-Express_2nd-January-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest533}`,
        url:'',
        alt:'Kerala-Bhooshanam-Daily_3rd-January-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest534}`,
        url:'',
        alt:'LOKMAT-22nd-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest535}`,
        url:'',
        alt:'LOKMAT-HELLO-MUMBAI-22nd-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest536}`,
        url:'',
        alt:'Lokmat-Hello-mumbai-paper_29th-December-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest537}`,
        url:'',
        alt:'Lokmat_25th-July-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest538}`,
        url:'',
        alt:'Lokmat_25th-July-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest539}`,
        url:'',
        alt:'MAHARASHTRA-TIMES-22nd-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest540}`,
        url:'',
        alt:'MUMBAI-TARUN-BHARAT-22-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest541}`,
        url:'',
        alt:'MUMBAI-TARUN-BHARAT-22nd-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest542}`,
        url:'',
        alt:'Maharashtra-Times_25th-July-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest543}`,
        url:'',
        alt:'Medical-Dialogues'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest544}`,
        url:'',
        alt:'Mission-Journalism_24th-July-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest545}`,
        url:'',
        alt:'NAVBHARAT-22nd-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest546}`,
        url:'',
        alt:'NAVBHARAT-TIMES-22nd-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest547}`,
        url:'',
        alt:'Navabharat-6th-Dec-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest548}`,
        url:'',
        alt:'Navbharat-Times-15th-Dec-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest549}`,
        url:'',
        alt:'Navbharat-Times-22nd-Dec-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest550}`,
        url:'',
        alt:'Navbharat-Times-29th-Dec-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest551}`,
        url:'',
        alt:'Navbharat-Times-8th-Dec-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest552}`,
        url:'',
        alt:'Navbharat-Times'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest553}`,
        url:'',
        alt:'Navbharat-Times_13th-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest554}`,
        url:'',
        alt:'Navbharat-Times_14th-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest555}`,
        url:'',
        alt:'Navbharat-times_31st-March-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest556}`,
        url:'',
        alt:'Navbharat times_221st-July-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest557}`,
        url:'',
        alt:'New-Age_1st-January-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest558}`,
        url:'http://www.newsharpal.in/the-yog-institute-feclitated-modi-newsharpal-in/',
        alt:'News-Harpal'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest559}`,
        url:'http://www.newsharpal.in/the-yog-institute-feclitated-modi-newsharpal-in/',
        alt:'News18'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest560}`,
        url:'',
        alt:'NewsBytes_6th-Jan-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest561}`,
        url:'',
        alt:'Nyoooz_6th-Jan-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest562}`,
        url:'',
        alt:'Peoples-Samachar_6th-January-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest563}`,
        url:'',
        alt:'SANDESH-22-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest564}`,
        url:'',
        alt:'Samana-paper_28th-December-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest565}`,
        url:'',
        alt:'Samana-paper_29th-December-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest566}`,
        url:'',
        alt:'Sandesh-Gujarati_19th-December-2018'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest567}`,
        url:'',
        alt:'Sanjeevni-Today_25th-July-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest568}`,
        url:'',
        alt:'Swadesh_31st-January-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest569}`,
        url:'',
        alt:'Swatantra-Chetna_1st-January-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest570}`,
        url:'',
        alt:'THE-HINDU'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest571}`,
        url:'',
        alt:'The-Indian-Express_2nd-January-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest572}`,
        url:'',
        alt:'The-Indian-Express_5th-February-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest573}`,
        url:'',
        alt:'The-New-Indian-Express_1st-Jan-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest574}`,
        url:'',
        alt:'The-Times-of-India_19th-Feb-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest575}`,
        url:'',
        alt:'The-Times-of-India_1st-April-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest576}`,
        url:'',
        alt:'The-Times-of-India_1st-April-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest577}`,
        url:'',
        alt:'The-Times-of-India_2nd-February-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest578}`,
        url:'',
        alt:'The-Times-of-India_30th-January-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest579}`,
        url:'',
        alt:'The-Times-of-India_31st-January-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest580}`,
        url:'',
        alt:'The-Times-of-India_4th-February-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest581}`,
        url:'',
        alt:'Times-of-India_16th-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest582}`,
        url:'https://timesofindia.indiatimes.com/life-style/beauty/skin-essentials-for-a-festive-facial-glow/articleshow/71659097.cms',
        alt:'Times-of-india-india-times'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest583}`,
        url:'',
        alt:'UNN'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest584}`,
        url:'',
        alt:'VRUTTA-MANAS-22nd-June-2019'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest585}`,
        url:'http://everythingexperiential.businessworld.in/article/The-Yoga-Institute-celebrates-inclusiveness-with-yoga/21-11-2019-179326/',
        alt:'everything-experimental'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest586}`,
        url:'https://www.herzindagi.com/fitness/yoga-asanas-for-thyroid-patients-by-expert-article-134620',
        alt:'her zindagi'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest587}`,
        url:'https://hindmatanews.blogspot.com/2019/07/the-yoga-institute-brings-100-year-old.html?m=1',
        alt:'hindmata-prime-news-tyi'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest588}`,
        url:'http://mumbainewsexpress.com/the-yoga-institute-celebrates-inclusiveness-with-yoga/',
        alt:'mumbai-news-express'
      }
    ]
  },
  {
    year:'2020',
    media:[
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest589}`,
        url:'',
        alt:'AAJ-KANPUR-9-Yoga-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest590}`,
        url:'',
        alt:'AJ-DI-AWAAZ-11-Yoga-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest591}`,
        url:'',
        alt:'AKALI-PATRIKA-Page-No-6-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest592}`,
        url:'',
        alt:'AKALI-PATRIKA-Page-No.-6-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest593}`,
        url:'',
        alt:'AZAD-SOCH-Page-No.-3-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest594}`,
        url:'',
        alt:'Aapka-Faisla-7-Yoga-Ludhiana-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest595}`,
        url:'',
        alt:'Aapka-Faisla-Page-no.-5-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest596}`,
        url:'',
        alt:'Amoghavani-Page-No.-3-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest597}`,
        url:'',
        alt:'Amrit-Sandesh-Raipur-Page-No.-12-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest598}`,
        url:'http://arthnitimagazine.blogspot.com/2020/06/blog-post_91.html',
        alt:'Arthniti-tyi-article-june-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest599}`,
        url:'',
        alt:'Buland-Bharat-Bareilly-Page-No.-4-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest600}`,
        url:'https://www.businessinsider.in/india/news/12-yoga-poses-you-should-never-try-at-home-without-supervision-according-to-yoga-experts/slidelist/76477223.cms',
        alt:'Bussiness-insider-tyi-june-20'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest601}`,
        url:'',
        alt:'Central-Chronicle-Raipur-Page-No.-7-28th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest602}`,
        url:'',
        alt:'Chaitanyaa-Lok_Indore-Page-no.-5-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest603}`,
        url:'',
        alt:'Chandi-Bhumi-Page-No.-6-28th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest604}`,
        url:'',
        alt:'Chandrapur-Samachar-Nagpur-Page-No.-7-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest605}`,
        url:'',
        alt:'DAILY-MILAP-Page-No.-12-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest606}`,
        url:'',
        alt:'DAILY-SURAJ-Page-No.-2-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest607}`,
        url:'',
        alt:'DHABKAR-Page-No.-6-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest608}`,
        url:'',
        alt:'Dainik-Bhaskar-Bareilly-Page-No.-10-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest609}`,
        url:'',
        alt:'Dainik-Bhaskar-Meerut-Page-No.-10-28th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest610}`,
        url:'',
        alt:'Dainik-Jagran-Inext-Bareilly-Page-No.-9-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest611}`,
        url:'',
        alt:'Dainik-Jagran-Inext_Meerut-Page-No.-9-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest612}`,
        url:'https://www.herzindagi.com/fitness/nearing-40-years-of-age-then-these-yoga-asanas-viparit-karni-parvat-asana-are-for-you-by-yoga-expert-article-15',
        alt:'Dainik-Jagran-lifestyle-online-harzindagi-10th-feb-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest613}`,
        url:'https://www.herzindagi.com/hindi/fitness/anti-ageing-yoga-asanas-surya-namaskar-kapalbhati-by-expert-article-152970',
        alt:'Dainik-Jagran-lifestyle-online-harzindagi-13th-feb-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest614}`,
        url:'https://www.herzindagi.com/hindi/fitness/yoga-asanas-for-hair-fall-control-and-fast-growth-by-expert-article-153071',
        alt:'Dainik-Jagran-lifestyle-online-harzindagi-15th-feb-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest615}`,
        url:'https://www.herzindagi.com/hindi/fitness/best-expert-yoga-asanas-for-women-under45-article-152382',
        alt:'Dainik-Jagran-lifestyle-online-harzindagi-2nd-feb-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest616}`,
        url:'https://www.herzindagi.com/fitness/signs-of-ageing-worrying-practice-these-anti-ageing-yoga-asanas-surya-namaskar-kapalbhati-by-expert-article-152597',
        alt:'Dainik-Jagran-lifestyle-online-harzindagi-6th-feb-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest617}`,
        url:'https://www.herzindagi.com/fitness/revive-lifeless-hair-promote-hair-growth-with-hastapadasana-sarvangasana-yoga-asanas-says-expert-article-152637',
        alt:'Dainik-Jagran-lifestyle-online-harzindagi-7th-feb-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest618}`,
        url:'',
        alt:'Desh-bhandhu-Page-No.-11-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest619}`,
        url:'',
        alt:'Deshbandhu-Meerut-Page-No.-9-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest620}`,
        url:'',
        alt:'Devboomi-Yoga-Ludhiana-Page-no.-7-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest621}`,
        url:'',
        alt:'Devboomi-Yoga-Ludhiana-Page-no.-7-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest622}`,
        url:'',
        alt:'Dhara-News-Meerut-Page-No.-3-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest623}`,
        url:'',
        alt:'Dittadhwani-Page-no.-1-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest624}`,
        url:'',
        alt:'Divya-Vishvas-Meerut-Page-No.-4-28th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest625}`,
        url:'',
        alt:'Gujarat-Guardian-Page-No.-4-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest626}`,
        url:'',
        alt:'Hallie-Sandesh-Page-No.-5-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest627}`,
        url:'',
        alt:'Hari-Bhoomi-Page-No.-5-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest628}`,
        url:'',
        alt:'Hari-Bhoomi-page-Number-5-26th-december-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest629}`,
        url:'',
        alt:'Hasiru-Kranti-Page-No.-3-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest630}`,
        url:'',
        alt:'Hello-Madras-Page-no.-2-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest631}`,
        url:'',
        alt:'Hello-Mysore-Page-No.-5-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest632}`,
        url:'',
        alt:'Himprabha-Page-No.-2-28th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest633}`,
        url:'https://www.healthshots.com/healthy-eating/nutrition/yoga-practitioners-take-on-intermittent-fasting/',
        alt:'Hindustan-times-health-shots-17th-feb-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest634}`,
        url:'',
        alt:'Hint-Meerut-Page-No.-6-28th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest635}`,
        url:'',
        alt:'Hosadigantha-Page-No.-8-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest636}`,
        url:'',
        alt:'Hubali-Sanje-Page-No.-2-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest637}`,
        url:'',
        alt:'Human-India-7-Yoga-Ludhiana-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest638}`,
        url:'',
        alt:'Ispat-Times-Raipur-Page-No.-4-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest639}`,
        url:'',
        alt:'JAGRITI-LEHAR-Page-No.-4-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest640}`,
        url:'',
        alt:'Jabalpur Express- Page No.26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest641}`,
        url:'',
        alt:'Jansandesh-Times_Bareilly-Page-No.-10-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest642}`,
        url:'',
        alt:'Jigyasa-Kunj_Meerut-Page-No.-3-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest643}`,
        url:'',
        alt:'Kahi-Ankahi-Raipur-Page-No.-5-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest644}`,
        url:'',
        alt:'Kaifiyat-Page-No.-5-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest645}`,
        url:'',
        alt:'Karavali-Ale-Page-No.-3-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest646}`,
        url:'',
        alt:'Kolhapur-Mahasatta-Page-No.-8-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest647}`,
        url:'',
        alt:'Kolhapur-Samaj-Page-No.-2-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest648}`,
        url:'',
        alt:'Kolhapur-Swatantra-Pragati-Page-No.-2-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest649}`,
        url:'',
        alt:'Kolhapur-Varta-Shakti-Page-No.-2-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest650}`,
        url:'',
        alt:'Lokdarpan-Vadodara-Page-no.-104-28th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest651}`,
        url:'https://www.lokmat.com/health/these-will-do-magic-seven-yoga-poses/',
        alt:'Lokmat-28-feb-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest652}`,
        url:'',
        alt:'Loksatya-Meerut-Page-No.-3-28th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest653}`,
        url:'',
        alt:'Loktej-Page-No.-3-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest654}`,
        url:'',
        alt:'Makkal-Karuththu-Page-no.-4-28th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest655}`,
        url:'',
        alt:'Mayur-Samvad-Page-No.-6-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest656}`,
        url:'',
        alt:'Media-Darshan-Page-No.-5-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest657}`,
        url:'',
        alt:'Media-Seithi-Page-no.-3-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest658}`,
        url:'https://www.mid-day.com/articles/here-s-how-social-media-helped-yoga-flourish-through-across-the-globe/22632223',
        alt:'Mid-day-19-feb-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest659}`,
        url:'',
        alt:'Motherland-voice-5-Yoga-Ludhiana-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest660}`,
        url:'',
        alt:'Mysore-Digantha-Page-No.-3-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest661}`,
        url:'https://epaper.navbharattimes.com/imageview_14902_73801_4_16_11-10-2020_6_i_1_sf.html',
        alt:'Navbharat times-11th-Oct-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest662}`,
        url:'https://epaper.navbharattimes.com/imageview_6128_81370_4_16_15-11-2020_2_i_1_sf.html',
        alt:'Navbharat times-15th-Nov-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest663}`,
        url:'https://epaper.navbharattimes.com/imageview_6597_80773_4_16_16-08-2020_2_i_1_sf.html',
        alt:'Navbharat times-16th-August-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest664}`,
        url:'https://epaper.navbharattimes.com/imageview_2670_81180_4_16_19-07-2020_2_i_1_sf.html',
        alt:'Navbharat times-19th-July-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest665}`,
        url:'https://epaper.navbharattimes.com/imageview_3685_76964_4_16_01-11-2020_2_i_1_sf.html',
        alt:'Navbharat times-1st-Nov-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest666}`,
        url:'https://epaper.navbharattimes.com/imageview_6962_77441_4_16_22-11-2020_2_i_1_sf.html',
        alt:'Navbharat times-22nd-Nov-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest667}`,
        url:'https://epaper.navbharattimes.com/imageview_2487_74690_4_16_25-10-2020_6_i_1_sf.html',
        alt:'Navbharat times-25th-Oct-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest668}`,
        url:'https://epaper.navbharattimes.com/imageview_3669_80003_4_16_26-07-2020_4_i_1_sf.html',
        alt:'Navbharat times-26th-july-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest669}`,
        url:'http://archives.epaper.navbharattimes.com/details/114508-75217-1.html',
        alt:'Navbharat times-28th-June-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest670}`,
        url:'https://epaper.navbharattimes.com/imageview_8009_77250_4_16_29-11-2020_2_i_1_sf.html',
        alt:'Navbharat times-29th-Nov-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest671}`,
        url:'https://epaper.navbharattimes.com/imageview_4492_77918_4_16_02-08-2020_2_i_1_sf.html',
        alt:'Navbharat times-2nd-August-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest672}`,
        url:'http://epaper.navbharattimes.com/imageview_835_75141_4_16_05-07-2020_2_i_1_sf.html',
        alt:'Navbharat times-5th-July-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest673}`,
        url:'https://epaper.navbharattimes.com/imageview_4970_77718_4_16_08-11-2020_2_i_1_sf.html',
        alt:'Navbharat times-8th-Nov-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest674}`,
        url:'https://theyogainstitute.org/wp-content/uploads/2020/09/Navbharat-times-13th-September-2020.jpg',
        alt:'Navbharat-times-13th-September-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest675}`,
        url:'https://theyogainstitute.org/wp-content/uploads/2020/09/Navbharat-times-20th-September-2020.jpg',
        alt:'Navbharat-times-20th-September-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest676}`,
        url:'https://theyogainstitute.org/wp-content/uploads/2020/09/Navbharat-times-27th-September-2020.jpg',
        alt:'Navbharat-times-27th-September-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest677}`,
        url:'https://theyogainstitute.org/wp-content/uploads/2020/09/Navbharat-times-30th-August-2020.jpg',
        alt:'Navbharat-times-30th-August-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest678}`,
        url:'https://epaper.navbharattimes.com/imageview_13952_75586_4_16_04-10-2020_2_i_1_sf.html',
        alt:'Navbharat-times-4th-Oct-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest679}`,
        url:'https://theyogainstitute.org/wp-content/uploads/2020/09/Navbharat-times-6th-September-2020.jpg',
        alt:'Navbharat-times-6th-September-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest680}`,
        url:'',
        alt:'Navbharat times-10th-May-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest681}`,
        url:'',
        alt:'Navbharat times-12th-April-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest682}`,
        url:'https://epaper.navbharattimes.com/imageview_9767_76051_4_16_13-12-2020_2_i_1_sf.html',
        alt:'Navbharat times-13th-Dec-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest683}`,
        url:'https://theyogainstitute.org/wp-content/uploads/2020/06/Navbharattimes-14th-June-2020.jpg',
        alt:'Navbharat times-14th-June-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest684}`,
        url:'',
        alt:'Navbharat times-15th-March-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest685}`,
        url:'',
        alt:'Navbharat times-16th-February-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest686}`,
        url:'',
        alt:'Navbharat times-17th-May-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest687}`,
        url:'',
        alt:'Navbharat times-19th-April-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest688}`,
        url:'https://epaper.navbharattimes.com/imageview_10995_79600_4_16_20-12-2020_2_i_1_sf.html',
        alt:'Navbharat times-20th-Dec-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest689}`,
        url:'',
        alt:'Navbharat times-22nd-March-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest690}`,
        url:'',
        alt:'Navbharat times-23rd-February-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest691}`,
        url:'',
        alt:'Navbharat times-24th-May-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest692}`,
        url:'',
        alt:'Navbharat times-26th-April-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest693}`,
        url:'https://epaper.navbharattimes.com/imageview_11983_71224_4_16_26-12-2020_2_i_1_sf.html',
        alt:'Navbharat times-26th-Dec-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest694}`,
        url:'',
        alt:'Navbharat times-26th-January-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest695}`,
        url:'https://epaper.navbharattimes.com/imageview_12183_76982_4_16_27-12-2020_2_i_1_sf.html',
        alt:'Navbharat times-27th-Dec-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest696}`,
        url:'',
        alt:'Navbharat times-29th-march-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest697}`,
        url:'',
        alt:'Navbharat times-31st-May-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest698}`,
        url:'',
        alt:'Navbharat times-3rd-May-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest699}`,
        url:'',
        alt:'Navbharat times-5th-April-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest700}`,
        url:'',
        alt:'Navbharat times-5th-January-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest701}`,
        url:'https://epaper.navbharattimes.com/imageview_9015_77230_4_16_06-12-2020_4_i_1_sf.html',
        alt:'Navbharat times-6th-Dec-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest702}`,
        url:'',
        alt:'Navbharat times-7th-June-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest703}`,
        url:'',
        alt:'Navbharat times-8th-March-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest704}`,
        url:'',
        alt:'Navbharat times-9th-February-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest705}`,
        url:'',
        alt:'Navgujarat-Times-Page-No.-3-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest706}`,
        url:'',
        alt:'Nawan-Zamana-Page-No.-11-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest707}`,
        url:'',
        alt:'Odayara-Naadu-Page-No.-3-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest708}`,
        url:'',
        alt:'Prachand-Samay-Page-no.-4-28th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest709}`,
        url:'',
        alt:'Pratidin-Rajdhani-Raipur-Page-No.-8-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest710}`,
        url:'',
        alt:'Punjab-Times-Page-No.-5-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest711}`,
        url:'https://timesofindia.indiatimes.com/entertainment/hindi/music/news/rahul-sharma-to-play-santoor-for-yoga-enthusiasts-around-the-world/articleshow/76452043.cms',
        alt:'Rahul-sharmaperforming-tyi-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest712}`,
        url:'',
        alt:'Raj-Express-Page-No.-7-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest713}`,
        url:'',
        alt:'Rajya-Dharma-Page-No.-6-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest714}`,
        url:'',
        alt:'Rashtriya-Sakshi-Bareilly-Page-No.-3-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest715}`,
        url:'',
        alt:'Rashtriya-Waroop-Bareilly-Page-No.-7-28th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest716}`,
        url:'',
        alt:'Ratnagiri-Ranzunjar-Page-No.-3-28th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest717}`,
        url:'',
        alt:'Rozana-news-2-Yoga-%E2%80%93-Ludhiana-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest718}`,
        url:'',
        alt:'Samatola-Page-No.-6-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest719}`,
        url:'',
        alt:'Samay-Darshan-Raipur-Page-no.-03-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest720}`,
        url:'',
        alt:'Sanje-Drafan-Page-No.-2-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest721}`,
        url:'',
        alt:'Sanje-Mitra-Page-No.-3-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest722}`,
        url:'',
        alt:'Sanje-Mitra-Page-No.-5-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest723}`,
        url:'',
        alt:'Sanje-Mitra-Page-no.-5-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest724}`,
        url:'',
        alt:'Sanje-Vani-Page-No.-2-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest725}`,
        url:'',
        alt:'Sanjevani-Page-no.-04-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest726}`,
        url:'',
        alt:'Sanmarg-Page-No.-5-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest727}`,
        url:'',
        alt:'Satara-Mahasatta-Page-no.-8-%E2%80%93-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest728}`,
        url:'',
        alt:'Shah-Bulletin-Meeurt-Page-No.-1-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest729}`,
        url:'',
        alt:'Spasth-Awaz-Bareilly-Page-no.-10-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest730}`,
        url:'',
        alt:'Suvarna-Loka-Page-no.-8-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest731}`,
        url:'',
        alt:'Swatantra-Bharat-Bareilly-Page-no.-14-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest732}`,
        url:'',
        alt:'Tamil-Anjal-Page-no.-3-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest733}`,
        url:'',
        alt:'Tarun-Bharat-Nagpur-Page-no.-9-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest734}`,
        url:'https://www.mid-day.com/articles/the-big-stretch/22848217',
        alt:'The-big-stretch-mid-day-june-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest735}`,
        url:'https://timesofindia.indiatimes.com/life-style/health-fitness/health-news/mumbais-oldest-yoga-institute-to-host-multiple-online-activities-for-international-day-of-yoga/articleshow/76448742.cms',
        alt:'Times-of-india-entertainment-internation-yoga-day-june-18th'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest736}`,
        url:'',
        alt:'Veekshanam-Page-no.-05-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest737}`,
        url:'',
        alt:'Vidarbha-Ki-Baat-Nagpur-Page-no.-02-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest738}`,
        url:'',
        alt:'Vishwa-Pariwar-Raipur-Page-no.-7-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest739}`,
        url:'',
        alt:'Y-GGN-Action-India-Page-no.-09-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest740}`,
        url:'',
        alt:'Y-GGN-Hadoti-Adhikar-Page-no.-7-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest741}`,
        url:'',
        alt:'Y-GGN-Haryana-Jyoti-Page-no.-04-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest742}`,
        url:'',
        alt:'Y-GGN-Haryana-Ki-Awaz-Page-no.-05-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest743}`,
        url:'',
        alt:'Y-GGN-Haryana-Vatika-Page-no.-05-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest744}`,
        url:'',
        alt:'Y-GGN-Jyoti-Darpan-Page-no.-05-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest745}`,
        url:'',
        alt:'Y-GGN-Pioneer-Page-no.-05-28th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest746}`,
        url:'',
        alt:'Y-GGN-Satyajai-Times-Page-no.-05-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest747}`,
        url:'',
        alt:'Y-GGN-Satyajai-Times-Page-no.-105-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest748}`,
        url:'',
        alt:'Y-KNL-Aapka-Faisla-no.-2-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest749}`,
        url:'',
        alt:'Y-KNL-Action-India-Page-no.-09-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest750}`,
        url:'',
        alt:'Y-KNL-Rozana-Page-no.-2-28th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest751}`,
        url:'',
        alt:'Y-KNLGhoshna-Patra-Page-no.-104-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest752}`,
        url:'',
        alt:'Y-RTK-Amar-Bharti-Page-no.-6-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest753}`,
        url:'',
        alt:'YOGSADHNA-SANJSHAKTI-Page-no.-03-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest754}`,
        url:'',
        alt:'YOGSADHNA-SHASAN-SAMRAT-Page-no.-3-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest755}`,
        url:'',
        alt:'Yoga-Pradesh-Today-Bhopal-Page-no.-11-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest756}`,
        url:'',
        alt:'Yoga-Pradesh-Today-Bhopal-Page-no.-11-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest757}`,
        url:'',
        alt:'Yoga-Raj-Express-Indore-Page-no.-107-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest758}`,
        url:'',
        alt:'Yoga-Repoter-Page-no.-5-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest759}`,
        url:'',
        alt:'Yoga-Sach-Express-Bhopal-Page-no.-11-26th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest760}`,
        url:'',
        alt:'Yogsadhna-Aurangabad-Samachar-Page-no.-3-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest761}`,
        url:'',
        alt:'Yogsadhna-Dainik-Bhaskar-Page-no.-5-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest762}`,
        url:'',
        alt:'Yogsadhna-Global-Bharat-Page-no.-3-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest763}`,
        url:'',
        alt:'Yogsadhna-Global-Bharat-Page-no.-3-27th-December-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest764}`,
        url:'https://timesofindia.indiatimes.com/business/india-business/castrol-india-takes-initiative-to-improve-health-of-truckers-farmers/articleshow/76470254.cms',
        alt:'castrol-india-take-initiative-june-19th-tyi'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest765}`,
        url:'https://www.india.com/travel/articles/top-9-yoga-centres-in-india-that-will-leave-you-feeling-refreshed-3237147/',
        alt:'India.com-25-feb-2020'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest766}`,
        url:'https://www.luxebook.in/the-yoga-institute-in-mumbai-has-been-teaching-yoga-to-the-world-one-foreign-student-at-a-time/?preview=true',
        alt:'international-day-tyi-luxebook-18th-june'
      }
    ]
  },
  {
    year:'2021',
    media:[
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest767}`,
        url:'',
        alt:'Aadarsh Maharashta-The-Yoga-Institute-17th-May-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest768}`,
        url:'',
        alt:'Dabang-Duniya_PG-03_22nd-June-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest769}`,
        url:'',
        alt:'Dabang-Duniya_PG-03_22nd-June-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest770}`,
        url:'',
        alt:'Dainik-Bhaskar-16th-May-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest771}`,
        url:'',
        alt:'Dainik-Bhaskar-7th-April-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest772}`,
        url:'https://www.freepressjournal.in/mumbai/ayush-64-for-covid-19-treatment-heres-how-you-can-get-the-ayurvedic-drug-free-of-cost-in-mumbai',
        alt:'Free-Press-Journal-28th-May-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest773}`,
        url:'',
        alt:'Hamara-Mahanagar-22nd-June-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAsses774}`,
        url:'',
        alt:'Hindustan-samachaar-28th-May-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest775}`,
        url:'http://dhunt.in/fvpg8?s=a&uu=0x05be2dab26c55b24&ss=wsp',
        alt:'Hindusthan-Samachar-15th-May-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest776}`,
        url:'',
        alt:'Janmabhoomi-22nd-June-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest777}`,
        url:'',
        alt:'JanmbhoomiMumbai16th-May-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest778}`,
        url:'',
        alt:'Nav-Bharat-Times-17th-May-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest779}`,
        url:'',
        alt:'Navbaharat-22nd-June-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest780}`,
        url:'https://epaper.navbharattimes.com/imageview_19137_77471_4_16_07-02-2021_2_i_1_sf.html',
        alt:'Navbharattime-7th-Feb-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest781}`,
        url:'https://epaper.navbharattimes.com/imageview_55279_67332_4_16_10-10-2021_4_i_1_sf.html',
        alt:'Navbharat times-10th-October 2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest782}`,
        url:'https://epaper.navbharattimes.com/imageview_29279_74443_4_16_11-04-2021_2_i_1_sf.html',
        alt:'Navbharat times-11th-April-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest783}`,
        url:'https://epaper.navbharattimes.com/imageview_40930_76501_4_16_11-07-2021_2_i_1_sf.html',
        alt:'Navbharat times-11th-July-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest784}`,
        url:'https://epaper.navbharattimes.com/imageview_50714_72292_4_16_12-09-2021_9_i_1_sf.html',
        alt:'Navbharat times-12th-September-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest785}`,
        url:'https://epaper.navbharattimes.com/imageview_67178_76114_4_16_13-12-2021_4_i_1_sf.html',
        alt:'Navbharat times-13th Dec-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest786}`,
        url:'https://epaper.navbharattimes.com/imageview_37376_73056_4_16_13-06-2021_2_i_1_sf.html',
        alt:'Navbharat times-13th-june-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest787}`,
        url:'https://epaper.navbharattimes.com/imageview_20267_79417_4_16_14-02-2021_2_i_1_sf.html',
        alt:'Navbharat times-14th-Feb-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest788}`,
        url:'https://epaper.navbharattimes.com/imageview_25021_78450_4_16_14-03-2021_2_i_1_sf.html',
        alt:'Navbharat times-14th-March-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest789}`,
        url:'https://epaper.navbharattimes.com/imageview_62249_70948_4_16_14-11-2021_2_i_1_sf.html',
        alt:'Navbharat times-14th-Nov-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest790}`,
        url:'https://epaper.navbharattimes.com/imageview_46810_76853_4_16_15-08-2021_10_i_1_sf.html',
        alt:'Navbharat times-15th-August-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest791}`,
        url:'https://epaper.navbharattimes.com/imageview_33781_72337_4_16_16-05-2021_5_i_1_sf.html',
        alt:'Navbharat times-16th-May-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest792}`,
        url:'https://epaper.navbharattimes.com/imageview_15508_76147_4_16_17-01-2021_6_i_1_sf.html',
        alt:'Navbharat times-17th-Jan-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest793}`,
        url:'https://epaper.navbharattimes.com/imageview_56789_76472_4_16_17-10-2021_4_i_1_sf.html',
        alt:'Navbharat times-17th-October-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest794}`,
        url:'https://epaper.navbharattimes.com/imageview_30377_76200_4_16_18-04-2021_2_i_1_sf.html',
        alt:'Navbharat times-18th-April-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest795}`,
        url:'https://epaper.navbharattimes.com/imageview_42120_76843_4_16_18-07-2021_2_i_1_sf.html',
        alt:'Navbharat times-18th-July-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest796}`,
        url:'https://epaper.navbharattimes.com/imageview_37878_75777_4_16_18-06-2021_2_i_1_sf.html',
        alt:'Navbharat times-18th-June-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest797}`,
        url:'https://epaper.navbharattimes.com/imageview_56966_74867_4_16_18-10-2021_2_i_1_sf.html',
        alt:'Navbharat times-18th-October-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest798}`,
        url:'https://epaper.navbharattimes.com/imageview_51997_76284_4_16_19-09-2021_6_i_1_sf.html',
        alt:'Navbharat times-19th -September-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest799}`,
        url:'https://epaper.navbharattimes.com/imageview_68206_79867_4_16_19-12-2021_6_i_1_sf.html',
        alt:'Navbharat times-19th-Dec-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest800}`,
        url:'https://epaper.navbharattimes.com/imageview_44482_70438_4_16_01-08-2021_2_i_1_sf.html',
        alt:'Navbharat times-1st-August-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest801}`,
        url:'https://epaper.navbharattimes.com/imageview_68392_70463_4_16_20-12-2021_4_i_1_sf.html',
        alt:'Navbharat times-20th-Dec-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest802}`,
        url:'https://image.mepaper.navbharattimes.com/epaperimages/20062021/20062021-md-mu-7.jpg',
        alt:'Navbharat times-20th-June-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest803}`,
        url:'https://epaper.navbharattimes.com/imageview_21391_69469_4_16_21-02-2021_2_i_1_sf.html',
        alt:'Navbharat times-21st-Feb-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest804}`,
        url:'https://epaper.navbharattimes.com/imageview_1155_78001_4_16_21-03-2021_2_i_1_sf.html',
        alt:'Navbharat times-21st-March-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest805}`,
        url:'https://epaper.navbharattimes.com/imageview_63479_71507_4_16_21-11-2021_2_i_1_sf.html',
        alt:'Navbharat times-21st-Nov-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest806}`,
        url:'https://epaper.navbharattimes.com/imageview_47996_75518_4_16_22-08-2021_2_i_1_sf.html',
        alt:'Navbharat times-22nd-August-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest807}`,
        url:'https://epaper.navbharattimes.com/imageview_38536_73134_4_16_22-06-2021_4_i_1_sf.html',
        alt:'Navbharat times-22nd-June-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest808}`,
        url:'',
        alt:'Navbharat times-23rd-May-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest809}`,
        url:'https://epaper.navbharattimes.com/imageview_16671_77004_4_16_24-01-2021_2_i_1_sf.html',
        alt:'Navbharat times-24th-Jan-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest810}`,
        url:'https://epaper.navbharattimes.com/imageview_58135_74480_4_16_24-10-2021_4_i_1_sf.html',
        alt:'Navbharat times-24th-October-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest811}`,
        url:'https://epaper.navbharattimes.com/imageview_43294_78893_4_16_25-07-2021_2_i_1_sf.html',
        alt:'Navbharat times-25th-july-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest812}`,
        url:'',
        alt:'Navbharat times-25th-April-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest813}`,
        url:'https://epaper.navbharattimes.com/imageview_69514_75421_4_16_26-12-2021_2_i_1_sf.html',
        alt:'Navbharat times-26th-Dec-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest814}`,
        url:'https://epaper.navbharattimes.com/imageview_69678_71745_4_16_27-12-2021_4_i_1_sf.html',
        alt:'Navbharat times-27th-Dec-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest815}`,
        url:'https://epaper.navbharattimes.com/imageview_39175_78382_4_16_27-06-2021_2_i_1_sf.html',
        alt:'Navbharat times-27th-June-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest816}`,
        url:'https://epaper.navbharattimes.com/imageview_22621_77081_4_16_28-02-2021_2_i_1_sf.html',
        alt:'Navbharat times-28th-Feb-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest817}`,
        url:'https://epaper.navbharattimes.com/imageview_22621_77081_4_16_28-02-2021_2_i_1_sf.html',
        alt:'Navbharat times-28th-Feb-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest818}`,
        url:'https://epaper.navbharattimes.com/imageview_64747_71825_4_16_28-11-2021_2_i_1_sf.html',
        alt:'Navbharat times-28th-Nov-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest819}`,
        url:'https://epaper.navbharattimes.com/imageview_49076_73728_4_16_29-08-2021_7_i_1_sf.html',
        alt:'Navbharat times-29th-August-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest820}`,
        url:'https://epaper.navbharattimes.com/imageview_49076_73728_4_16_29-08-2021_7_i_1_sf.html',
        alt:'Navbharat times-29th-August-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest821}`,
        url:'https://epaper.navbharattimes.com/imageview_49076_73728_4_16_29-08-2021_7_i_1_sf.html',
        alt:'Navbharat times-29th-August-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest822}`,
        url:'',
        alt:'Navbharat times-2nd-May-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest823}`,
        url:'https://epaper.navbharattimes.com/imageview_35650_75631_4_16_30-05-2021_4_i_1_sf.html',
        alt:'Navbharat times-30th-May-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest824}`,
        url:'https://epaper.navbharattimes.com/imageview_17913_76564_4_16_31-01-2021_2_i_1_sf.html',
        alt:'Navbharat times-31st-Jan-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest825}`,
        url:'https://epaper.navbharattimes.com/imageview_59857_76021_4_16_31-10-2021_6_i_1_sf.html',
        alt:'Navbharat times-31st-October-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest826}`,
        url:'https://epaper.navbharattimes.com/imageview_85489_74200_4_16_03-04-2022_2_i_1_sf.html',
        alt:'Navbharat times-3rd-April-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest827}`,
        url:'https://epaper.navbharattimes.com/imageview_55279_67332_4_16_10-10-2021_4_i_1_sf.html',
        alt:'Navbharat times-3rd-October-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest828}`,
        url:'https://epaper.navbharattimes.com/imageview_28165_76874_4_16_04-04-2021_4_i_1_sf.html',
        alt:'Navbharat times-4th-April-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest829}`,
        url:'https://epaper.navbharattimes.com/imageview_85446_67116_4_16_04-04-2022_6_i_1_sf.html',
        alt:'Navbharat times-4th-April-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest830}`,
        url:'https://epaper.navbharattimes.com/imageview_39758_76503_4_16_04-07-2021_2_i_1_sf.html',
        alt:'Navbharat times-4th-July-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest831}`,
        url:'https://epaper.navbharattimes.com/imageview_49821_74793_4_16_05-09-2021_4_i_1_sf.html',
        alt:'Navbharat times-5th -September-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest832}`,
        url:'https://epaper.navbharattimes.com/imageview_67020_73524_4_16_12-12-2021_2_i_1_sf.html',
        alt:'Navbharat times-5th -dec-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest833}`,
        url:'',
        alt:'Navbharat times-6th-june-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest834}`,
        url:'https://epaper.navbharattimes.com/imageview_23671_76799_4_16_07-03-2021_2_i_1_sf.html',
        alt:'Navbharat times-7th march-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest835}`,
        url:'',
        alt:'Navbharat times-7th-nov-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest836}`,
        url:'https://epaper.navbharattimes.com/imageview_45629_73724_4_16_08-08-2021_2_i_1_sf.html',
        alt:'Navbharat times-8th-August-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest837}`,
        url:'https://epaper.navbharattimes.com/imageview_33055_74079_4_16_09-05-2021_5_i_1_sf.html',
        alt:'Navbharat times-9th May-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest838}`,
        url:'',
        alt:'Navshakti 22nd-June-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest839}`,
        url:'http://epaper.prahaar.in/detail.php?cords=888,1036,1432,1468&id=story10&pageno=http://epaper.prahaar.in/22062021/Mumbai/Page3.jpg',
        alt:'Prahaar 22nd-June-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest840}`,
        url:'',
        alt:'Pravasi-Edition-16th-May-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest841}`,
        url:'',
        alt:'Saamna-16th-May-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest842}`,
        url:'',
        alt:'The-Times-of-India-26th-April-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest843}`,
        url:'https://twistarticle.com/the-yoga-institute-mumbai-helping-ministry-of-ayush-with-free-distribution-of-ayush-64-for-covid-patients/',
        alt:'Twistarticle-28th-May-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest844}`,
        url:'http://www.educratsweb.com/content.php?id=6329',
        alt:'educrateweb-21st-june-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest845}`,
        url:'https://globalprimenews.com/2021/05/28/the-yoga-institute-mumbai-helping-ministry-of-ayush-with-free-distribution-of-ayurvedic-formulation-ayush-64-for-covid-patients/',
        alt:'globalpremennews 28th-May-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest846}`,
        url:'https://indiaeducationdiary.in/the-yoga-institute-mumbai-helping-ministry-of-ayush-with-free-distribution-of-ayurvedic-formulation-ayush-64-for-covid-patients/',
        alt:'india-education-diary-28th-May-2021'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest847}`,
        url:'https://onlineandyou.com/covid-19/the-yoga-institute-mumbai-helping-ministry-of-ayush-with-free-distribution-of-ayurvedic-formulation-ayush-64-for-covid-patients.html',
        alt:'onlineandyou-28th-May-2021'
      }
    ]
  },
  {
    year:'2022',
    media:[
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest947}`,
        url:'	https://epaper.navbharattimes.com/imageview_11518_68948_4_16_20-12-2022_6_i_1_sf.html',
        alt:'nbt-december20-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest948}`,
        url:'https://epaper.navbharattimes.com/imageview_12410_75547_4_16_25-12-2022_2_i_1_sf.html',
        alt:'nbt-december25-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest949}`,
        url:'https://epaper.navbharattimes.com/imageview_12680_73291_4_16_27-12-2022_6_i_1_sf.html ',
        alt:'nbt-december27-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest938}`,
        url:'https://epaper.navbharattimes.com/imageview_8916_76949_4_16_04-12-2022_6_i_1_sf.html',
        alt:'nbt-december4-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest939}`,
        url:'	https://epaper.navbharattimes.com/imageview_8975_58416_4_13_05-12-2022_10_i_1_sf.html',
        alt:'nbt-december5-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest940}`,
        url:'https://epaper-sakal-application.s3.ap-south-1.amazonaws.com/EpaperData/Sakal/Pune/2022/12/08/Main/Sakal_Pune_2022_12_08_Main_DA_003/44_130_1276_990.jpg',
        alt:'esakal-december8-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest941}`,
        url:'https://epaper.esakal.com/FlashClient/Client_Panel.aspx#',
        alt:'esakal-december8-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest942}`,
        url:'https://epaper.navbharattimes.com/imageview_10092_77252_4_16_11-12-2022_2_i_1_sf.html',
        alt:'nbt-december11-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest943}`,
        url:'	https://epaper.navbharattimes.com/imageview_10246_67423_4_16_12-12-2022_8_i_1_sf.html',
        alt:'nbt-december12-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest944}`,
        url:'https://epaper-sakal-application.s3.ap-south-1.amazonaws.com/EpaperData/Sakal/Pune/2022/12/12/Main/Sakal_Pune_2022_12_12_Main_GN_0102/44_1236_808_2430.jpg',
        alt:'esakal-december12-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest945}`,
        url:'https://epaper.navbharattimes.com/imageview_11242_77638_4_16_18-12-2022_6_i_1_sf.html',
        alt:'nbt-december18-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest946}`,
        url:'https://epaper.timesgroup.com/article-share?article=18_12_2022_017_016_toim_TOI',
        alt:'Times of India Mumbai-december18-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest936 }`,
        url:'https://epaper.navbharattimes.com/imageview_11242_77638_4_16_18-12-2022_6_i_1_sf.html',
        alt:'nbt-november13-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest937 }`,
        url:'	https://epaper.navbharattimes.com/imageview_7894_66581_4_16_28-11-2022_8_i_1_sf.html',
        alt:'nbt-november13-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest930 }`,
        url:'https://epaper.freepressjournal.in/3614878/Free-Press-Mumbai-Epaper-Edition/13-Nov-2022#page/17/2',
        alt:'nbt-november13-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest929}`,
        url:'',
        alt:'nbt-november16-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest933}`,
        url:'',
        alt:'midday-november19-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest935 }`,
        url:'https://epaper.navbharattimes.com/imageview_6582_81518_4_16_20-11-2022_2_i_1_sf.html',
        alt:'nbt-november20-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest934 }`,
        url:'https://epaper.navbharattimes.com/imageview_6742_67208_4_16_21-11-2022_6_i_1_sf.html',
        alt:'nbt-november21-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest932 }`,
        url:'https://epaper.navbharattimes.com/imageview_6742_67208_4_16_21-11-2022_6_i_1_sf.html',
        alt:'midday-november22-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest933 }`,
        url:'',
        alt:'nbt-november13-2022'
      },
      {
        img:`${ baseDomain }${ printMediaAssest.printMediaAssest928 }`,
        url:'https://epaper.navbharattimes.com/imageview_4273_75342_4_16_06-11-2022_2_i_1_sf.html',
        alt:'nbt-november6-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest927}`,
        url:'',
        alt:'Sakal-Paper-3rd-November-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest925}`,
        url:'https://epaper.navbharattimes.com/imageview_3286_79811_4_16_30-10-2022_4_i_1_sf.html',
        alt:'nbt-october30-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest926}`,
        url:'https://epaper.navbharattimes.com/imageview_3259_67154_4_16_31-10-2022_6_i_1_sf.html',
        alt:'nbt-october31-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest924}`,
        url:'https://epaper.navbharattimes.com/imageview_100656_67285_4_16_04-07-2022_6_i_1_sf.html',
        alt:'nbt-october23-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest848}`,
        url:'https://businessnewsweek.in/news/honble-cabinet-minister-piyush-goyal-to-grace-international-day-of-yoga-celebrations-on-tuesday-21-june-in-mumbai/',
        alt:'Bussiness-News-Week-20th-June-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest849}`,
        url:'http://businessnewsthisweek.com/news/honble-cabinet-minister-piyush-goyal-to-grace-international-day-of-yoga-celebrations-on-tuesday-21-june-in-mumbai/',
        alt:'Bussiness-News-this-Week-20th-June-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest850}`,
        url:'https://contentmediasolution.com/health/honble-cabinet-minister-piyush-goyal-to-grace-international-day-of-yoga-celebrations-on-tuesday-21-june-in-mumbai/',
        alt:'Content-Media-Solution-20th-June-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest851}`,
        url:'',
        alt:'Dainik Bhaskar-New Delhi--21st-June-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest852}`,
        url:'https://www.digitalfirstmagazine.com/honble-cabinet-minister-piyush-goyal-to-grace-international-day-of-yoga-celebrations-on-tuesday-21-june-in-mumbai/',
        alt:'Digital-First-Magazine-20th-June-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest853}`,
        url:'',
        alt:'Divya-Bhaskar-Bhuj-21st-June-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest854}`,
        url:'',
        alt:'Divya-Marathi-21st-June-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest855}`,
        url:'',
        alt:'Free-Press-Journal-PG04-22.06.22'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest856}`,
        url:'',
        alt:'Free-Press-Journal_PG08_22.06.22'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest857}`,
        url:'',
        alt:'Gujarat-Samachar-PG03-22.06.22'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest858}`,
        url:'',
        alt:'Hamara-Mahanagar-PG03-21.06.22'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest859}`,
        url:'',
        alt:'Janmabhoomi-news-papers-22nd-June-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest860}`,
        url:'',
        alt:'Lokmat-Helo-Mumbai-22nd-June'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest861}`,
        url:'Bulletins',
        alt:'Media-Bullitens-20th-June-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest862}`,
        url:'',
        alt:'Mid-Day-Gujarati-_pg15.21.06.22'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest863}`,
        url:'https://epaper.navbharattimes.com/imageview_73888_75613_4_16_23-01-2022_2_i_1_sf.html',
        alt:'NBT-23rd-Jan-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest864}`,
        url:'https://epaper.navbharattimes.com/imageview_86450_77452_4_16_10-04-2022_2_i_1_sf.html',
        alt:'NBT-10th-April-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest865}`,
        url:'https://epaper.navbharattimes.com/imageview_72034_70702_4_16_10-01-2022_4_i_1_sf.html',
        alt:'NBT-10th-Jan-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest866}`,
        url:'https://epaper.navbharattimes.com/imageview_86614_67036_4_16_11-04-2022_8_i_1_sf.html',
        alt:'NBT-11th-April-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest867}`,
        url:'https://epaper.navbharattimes.com/imageview_97010_80316_4_16_12-06-2022_2_i_1_sf.html',
        alt:'NBT-12th-June-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest868}`,
        url:'https://epaper.navbharattimes.com/imageview_77399_74216_4_16_13-02-2022_4_i_1_sf.html',
        alt:'NBT-13th-Feb-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest869}`,
        url:'https://epaper.navbharattimes.com/imageview_97164_66641_4_16_13-06-2022_6_i_1_sf.html',
        alt:'NBT-13th-June-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest870}`,
        url:'https://epaper.navbharattimes.com/imageview_81951_73730_4_16_13-03-2022_2_i_1_sf.html',
        alt:'NBT-13th-March-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest871}`,
        url:'https://epaper.navbharattimes.com/imageview_77549_77890_4_16_14-02-2022_4_i_1_sf.html',
        alt:'NBT-14th-Feb-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest872}`,
        url:'https://epaper.navbharattimes.com/imageview_82109_72499_4_16_14-03-2022_4_i_1_sf.html',
        alt:'NBT-14th-March-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest873}`,
        url:'https://epaper.navbharattimes.com/imageview_92368_79052_4_16_15-05-2022_4_i_1_sf.html',
        alt:'NBT-15th-May-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest874}`,
        url:'https://epaper.navbharattimes.com/imageview_73080_75541_4_16_16-01-2022_2_i_1_sf.html',
        alt:'NBT-16th-Jan-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest875}`,
        url:'https://epaper.navbharattimes.com/imageview_92550_66602_4_16_16-05-2022_8_i_1_sf.html',
        alt:'NBT-16th-May-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest876}`,
        url:'https://epaper.navbharattimes.com/imageview_87650_76372_4_16_17-04-2022_2_i_1_sf.html',
        alt:'NBT-17th-April-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest877}`,
        url:'https://epaper.navbharattimes.com/imageview_73226_70929_4_16_17-01-2022_4_i_1_sf.html',
        alt:'NBT-17th-Jan-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest878}`,
        url:'https://epaper.navbharattimes.com/imageview_87796_66870_4_16_18-04-2022_6_i_1_sf.html',
        alt:'NBT-18th-April-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest879}`,
        url:'https://epaper.navbharattimes.com/imageview_98196_76037_4_16_19-06-2022_2_i_1_sf.html',
        alt:'NBT-19th-June-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest880}`,
        url:'',
        alt:'NBT-1st-May-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest881}`,
        url:'https://epaper.navbharattimes.com/imageview_78561_70363_4_16_20-02-2022_2_i_1_sf.html',
        alt:'NBT-20th-Feb-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest882}`,
        url:'https://epaper.navbharattimes.com/imageview_98373_72149_4_16_20-06-2022_7_i_1_sf.html',
        alt:'NBT-20th-June-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest883}`,
        url:'https://epaper.navbharattimes.com/imageview_82962_71966_4_16_20-03-2022_7_i_1_sf.html',
        alt:'NBT-20th-March-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest884}`,
        url:'https://epaper.navbharattimes.com/imageview_78715_70463_4_16_21-02-2022_2_i_1_sf.html',
        alt:'NBT-21st-Feb-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest885}`,
        url:'https://epaper.navbharattimes.com/imageview_98520_73317_4_16_21-06-2022_4_i_1_sf.html',
        alt:'NBT-21st-June-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest886}`,
        url:'https://epaper.navbharattimes.com/imageview_98520_73317_4_16_21-06-2022_4_i_1_sf.html',
        alt:'NBT-21st-June-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest887}`,
        url:'https://epaper.navbharattimes.com/imageview_83113_66183_4_16_21-03-2022_6_i_1_sf.html',
        alt:'NBT-21st-March-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest888}`,
        url:'https://epaper.navbharattimes.com/imageview_93548_77612_4_16_22-05-2022_4_i_1_sf.html',
        alt:'NBT-22nd-May-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest889}`,
        url:'https://epaper.navbharattimes.com/imageview_93694_343063_4_16_23-05-2022_6_i_1_sf.html',
        alt:'NBT-23rd-May-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest890}`,
        url:'https://epaper.navbharattimes.com/imageview_88798_78868_4_16_24-04-2022_2_i_1_sf.html',
        alt:'NBT-24th-April-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest891}`,
        url:'https://epaper.navbharattimes.com/imageview_73870_69887_4_16_24-01-2022_4_i_1_sf.html',
        alt:'NBT-24th-Jan-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest892}`,
        url:'https://epaper.navbharattimes.com/imageview_88958_66788_4_16_25-04-2022_8_i_1_sf.html',
        alt:'NBT-25th-April-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest893}`,
        url:'https://epaper.navbharattimes.com/imageview_99324_75702_4_16_26-06-2022_4_i_1_sf.html',
        alt:'NBT-26th-June-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest894}`,
        url:'https://epaper.navbharattimes.com/imageview_79647_73994_4_16_27-02-2022_2_i_1_sf.html',
        alt:'NBT-27th-Feb-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest895}`,
        url:'https://epaper.navbharattimes.com/imageview_99480_67259_4_16_27-06-2022_6_i_1_sf.html',
        alt:'NBT-27th-June-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest896}`,
        url:'https://epaper.navbharattimes.com/imageview_84265_74220_4_16_27-03-2022_2_i_1_sf.html',
        alt:'NBT-27th-March-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest897}`,
        url:'https://epaper.navbharattimes.com/imageview_79617_69788_4_16_28-02-2022_6_i_1_sf.html',
        alt:'NBT-28th-Feb-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest898}`,
        url:'https://epaper.navbharattimes.com/imageview_79617_69788_4_16_28-02-2022_6_i_1_sf.html',
        alt:'NBT-28th-Feb-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest899}`,
        url:'https://epaper.navbharattimes.com/imageview_94730_77917_4_16_29-05-2022_2_i_1_sf.html',
        alt:'NBT-29th-May-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest900}`,
        url:'',
        alt:'NBT-2nd-May-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest901}`,
        url:'',
        alt:'NBT-30th-Jan-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest902}`,
        url:'https://epaper.navbharattimes.com/imageview_94890_66802_4_16_30-05-2022_8_i_1_sf.html',
        alt:'NBT-30th-May-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest903}`,
        url:'https://epaper.navbharattimes.com/imageview_75173_71003_4_16_31-01-2022_6_i_1_sf.html',
        alt:'NBT-31st-Jan-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest904}`,
        url:'https://epaper.navbharattimes.com/imageview_74993_75279_4_16_30-01-2022_2_i_1_sf.html',
        alt:'NBT-31st-Jan-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest905}`,
        url:'https://onlinemediacafe.com/health/honble-cabinet-minister-piyush-goyal-to-grace-international-day-of-yoga-celebrations-on-tuesday-21-june-in-mumbai/',
        alt:'Online-media-cafe-20th-june-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest906}`,
        url:'https://www.speakingtree.in/article/are-you-not-growing-fast-enough',
        alt:'Speaking-Tree'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest907}`,
        url:'https://www.thecambaypost.com/minister-piyush-goyal-to-grace-idy-celebrations-on-21-june-in-mumbai/',
        alt:'The-Cambay-Post-21st-june-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest908}`,
        url:'https://twistarticle.com/piyush-goyal-to-grace-the-international-day-of-yoga-celebrations-on-tuesday-21-june-in-mumbai/',
        alt:'Twistarticle-20th-june-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest909}`,
        url:'https://epaper.navbharattimes.com/imageview_104702_66966_4_16_01-08-2022_8_i_1_sf.html',
        alt:'nbt-aug1-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest910}`,
        url:'https://epaper.navbharattimes.com/imageview_106954_82666_4_16_14-08-2022_2_i_1_sf.html',
        alt:'bnbt-aug14-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest911}`,
        url:'https://epaper.navbharattimes.com/imageview_108314_70958_4_16_22-08-2022_6_i_1_sf.html',
        alt:'nbt-aug22-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest912}`,
        url:'https://epaper.navbharattimes.com/imageview_109314_77600_4_16_28-08-2022_2_i_1_sf.html',
        alt:'nbt-aug28-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest913}`,
        url:'https://epaper.navbharattimes.com/imageview_109476_71909_4_16_29-08-2022_6_i_1_sf.html',
        alt:'nbt-aug29-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest914}`,
        url:'https://epaper.navbharattimes.com/imageview_105777_22659552_4_16_07-08-2022_4_i_1_sf.html',
        alt:'nbt-aug7-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest915}`,
        url:'https://epaper.navbharattimes.com/imageview_105939_68611_4_16_08-08-2022_6_i_1_sf.html',
        alt:'nbt-aug8-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest916}`,
        url:'https://epaper.navbharattimes.com/imageview_101622_72416_4_16_10-07-2022_2_i_1_sf.html',
        alt:'nbt-july10-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest917}`,
        url:'https://epaper.navbharattimes.com/imageview_102478_77593_4_16_17-07-2022_2_i_1_sf.html',
        alt:'nbt-july17-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest918}`,
        url:'https://epaper.navbharattimes.com/imageview_102632_66995_4_16_18-07-2022_6_i_1_sf.html',
        alt:'nbt-july18-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest919}`,
        url:'https://epaper.navbharattimes.com/imageview_103521_76665_4_16_24-07-2022_2_i_1_sf.html',
        alt:'nbt-july24-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest920}`,
        url:'https://epaper.navbharattimes.com/imageview_103681_67796_4_16_25-07-2022_6_i_1_sf.html',
        alt:'nbt-july25-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest921}`,
        url:'https://epaper.navbharattimes.com/imageview_100512_74949_4_16_03-07-2022_4_i_1_sf.html',
        alt:'nbt-july3-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest922}`,
        url:'https://epaper.navbharattimes.com/imageview_104544_76625_4_16_31-07-2022_4_i_1_sf.html',
        alt:'nbt-july31-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest923}`,
        url:'https://epaper.navbharattimes.com/imageview_100656_67285_4_16_04-07-2022_6_i_1_sf.html',
        alt:'nbt-july4-2022'
      },
    ]
  },
  {
    year:'2023',
    media:[
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest988}`,
        url:'',
        alt:'Dainik Jagran - 21st June 2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest987}`,
        url:'https://epaper.navbharattimes.com/imageview_9524_68669_4_16_21-06-2023_2_i_1_sf.html',
        alt:'Navbharat Times - 21st June 2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest986}`,
        url: 'https://insamachar.com/aiia-launches-international-yoga-day-2023-celebrations/',
        alt:'Insamachar - 23rd May 2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest985}`,
        url:'https://www-aninews-in.translate.goog/news/national/general-news/yoga-day-2023-all-india-institute-of-ayurveda-kick-starts-celebrations-under-ministry-of-ayush20230522212734/?_x_tr_sl=en&_x_tr_tl=hi&_x_tr_hl=hi&_x_tr_pto=tc',
        alt:'Ani News - 23rd May 2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest984}`,
        url:'https://www.shiksha.com/news/medicine-health-sciences-aiia-kick-starts-its-international-yoga-day-2023-celebrations-blogId-125525',
        alt:'Shiksha - 23rd May 2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest983}`,
        url:'https://www.hindusthansamachar.in/Encyc/2023/5/22/AIIA-began-its-program-on-yoga-day.php',
        alt:'Hindusthan Samachar - 23rd May 2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest982}`,
        url:'https://pib.gov.in/PressReleaseIframePage.aspx?PRID=1926466',
        alt:'PressRelease - 22-05-2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest981}`,
        url:'https://timesofindia.indiatimes.com/blogs/voices/strengthen-your-nervous-system-with-this-mudra/',
        alt:'Toi-20-04-2023 ',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest980}`,
        url:'https://epaper.navarashtra.com/article-30-april-2023-kshitij-edition-kshitij/3-4/',
        alt:'kshitij-edition-30-April_2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest976}`,
        url:'https://epaper.navbharattimes.com/imageview_10153_70916_4_16_12-03-2023_4_i_1_sf.html',
        alt:'Navbharat_Times_Epaper-12th_March_2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest977}`,
        url:'https://epaper.navbharattimes.com/imageview_10317_67461_4_16_13-03-2023_6_i_1_sf.html',
        alt:'Navbharat_Times_Epaper-13th_March_2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest978}`,
        url:'https://epaper.navbharattimes.com/imageview_9209_78472_4_16_05-03-2023_4_i_1_sf.html',
        alt:'Navbharat_Times_Epaper-5th_March_2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest979}`,
        url:'https://epaper.navbharattimes.com/imageview_9357_68982_4_16_06-03-2023_6_i_1_sf.html',
        alt:'Navbharat_Times_Epaper-6th_March_2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest971}`,
        url:'https://epaper.navbharattimes.com/imageview_8223_67344_4_16_27-02-2023_6_i_1_sf.html',
        alt:'Navbharat_Times_Epaper-27th_February2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest972}`,
        url:'https://epaper.navbharattimes.com/imageview_8065_3400522_4_16_26-02-2023_6_i_1_sf.html',
        alt:'Navbharat_Time_Epaper-26th_February',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest973}`,
        url:'https://epaper-sakal-application.s3.ap-south-1.amazonaws.com/EpaperData/Sakal/Mumbai/2023/02/21/Main/Sakal_Mumbai_2023_02_21_Main_DA_006/44_34_1906_3014.jpg',
        alt:'Esaka_Epaper-21st_February_2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest974}`,
        url:'https://epaper-sakal-application.s3.ap-south-1.amazonaws.com/EpaperData/Sakal/Mumbai/2023/02/28/Main/Sakal_Mumbai_2023_02_28_Main_DA_008/1424_998_1904_2358.jpg',
        alt:'Esaka_Epaper-28th_February_2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest975}`,
        url:'https://www.freepressjournal.in/education/mumbai-yoga-session-at-st-xaviers-college-for-students-with-disabilities/',
        alt:'Freepressjournal.in-23rd_February_2023.',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest968}`,
        url:'https://epaper-sakal-application.s3.ap-south-1.amazonaws.com/EpaperData/Sakal/Mumbai/2023/02/14/Main/Sakal_Mumbai_2023_02_14_Main_DA_008/358_2388_1904_3014.jpg',
        alt:'Esaka_Epaper-14th_February_2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest969}`,
        url:'https://epaper.navbharattimes.com/imageview_6885_75735_4_16_19-02-2023_2_i_1_sf.html',
        alt:'Navbharat_Times_Epaper-19th_February_2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest970}`,
        url:'https://epaper.navbharattimes.com/imageview_7043_67324_4_16_20-02-2023_6_i_1_sf.html',
        alt:'Navbharat_Times_Epaper-20th_February_2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest963}`,
        url:'https://epaper.navbharattimes.com/imageview_4442_75814_4_16_05-02-2023_9_i_1_sf.html',
        alt:'Navbharat Times Epaper-5th February 2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest964}`,
        url:'https://epaper.navbharattimes.com/imageview_4605_67099_4_16_06-02-2023_8_i_1_sf.html',
        alt:'Navbharat Times Epaper-6th February 2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest965}`,
        url:'https://epaper.timesgroup.com/article-share?article=11_02_2023_008_014_etbg_ET',
        alt:'Navbharat Times Epaper-11th February 2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest966}`,
        url:'https://epaper.navbharattimes.com/imageview_5687_72262_4_16_12-02-2023_6_i_1_sf.html',
        alt:'Navbharat Times Epaper-12th February 2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest967}`,
        url:'https://epaper.navbharattimes.com/imageview_5837_67079_4_16_13-02-2023_6_i_1_sf.html',
        alt:'Navbharat Times Epaper-13th February 2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest958}`,
        url:'https://epaper-sakal-application.s3.ap-south-1.amazonaws.com/EpaperData/Sakal/Mumbai/2023/01/10/Main/Sakal_Mumbai_2023_01_10_Main_DA_008/1622_790_1906_3016.jpg',
        alt:'Esaka_Epaper-10th_January_2023',
      },
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest959}`,
        url:'https://epaper-sakal-application.s3.ap-south-1.amazonaws.com/EpaperData/Sakal/Mumbai/2023/01/17/Main/Sakal_Mumbai_2023_01_17_Main_DA_008/1622_862_1906_2862.jpg',
        alt:'Esaka_Epaper-17th_January_2023',
      }, 
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest960}`,
        url:'https://epaper.navbharattimes.com/imageview_1955_75124_4_16_22-01-2023_4_i_1_sf.html',
        alt:'NBT_22_JAN',
      }, 
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest961}`,
        url:'https://epaper.navbharattimes.com/imageview_3231_75462_4_16_29-01-2023_4_i_1_sf.html',
        alt:'NBT_29_JAN',
      }, 
      {
        img:`${baseDomain}${printMediaAssest.printMediaAssest962}`,
        url:'https://epaper.navbharattimes.com/imageview_3393_67181_4_16_30-01-2023_6_i_1_sf.html',
        alt:'NBT_31_JAN',
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest954}`,
        url:'https://epaper.navbharattimes.com/imageview_14540_78294_4_16_08-01-2023_2_i_1_sf.html',
        alt:'NBT-8JAN'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest955}`,
        url:'https://epaper.navbharattimes.com/imageview_14696_67514_4_16_09-01-2023_6_i_1_sf.html',
        alt:'NBT-9JAN'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest956}`,
        url:'http://epaper.hindisaamana.com/ArticlePage/APpage.php?edn=Hindi%20Saamana&articleid=SAMANA_HSAM_20230110_7_2&artwidth=155px',
        alt:'hindisaamana'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest957}`,
        url:'https://epaper.hamaramahanagar.net/clip/855',
        alt:'hamaramahanagar'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest950}`,
        url:'https://epaper.navbharattimes.com/imageview_13464_77604_4_16_01-01-2023_2_i_1_sf.html',
        alt:'nbt-january1-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest951}`,
        url:'	https://epaper.esakal.com/FlashClient/Client_Panel.aspx#currPage=10',
        alt:'sakal-january3-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest952}`,
        url:'	https://epaper.navbharattimes.com/imageview_13787_58221_4_13_04-01-2023_16_i_1_sf.html',
        alt:'nbt-january4-2022'
      },
      {
        img: `${baseDomain}${printMediaAssest.printMediaAssest953}`,
        url:'https://epaper.esakal.com/FlashClient/Show_Story_IPad.aspx?storySrc=aHR0cHM6Ly9lcGFwZXItc2FrYWwtYXBwbGljYXRpb24uczMuYXAtc291dGgtMS5hbWF6b25hd3MuY29tL0VwYXBlckRhdGEvU2FrYWwvTXVtYmFpLzIwMjMvMDEvMDMvTWFpbi9TYWthbF9NdW1iYWlfMjAyM18wMV8wM19NYWluX0RBXzAwOF9QUi5qcGcmcGc9MTA=&uname=&ipad=N',
        alt:'sakal-news-paper'
      },
      
      
    ]
  },
  {
    year:'2024',
    media:[
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/24+August+Story_News+18.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Aflatun.jpg`,
        url:'',
        alt:'2024',
      },
      // {
      //   img:`https://nispand.s3.ap-south-1.amazonaws.com/files/August+Story_News+18_+17+August+2024.jpg`,
      //   url: '',
      //   alt:'2024',
      // },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/bollywood-hungama.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Bollywood-Mascot.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/DD+News_30th+December+A.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Deccan-Herlad.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Filmy-Charcha.jpg`,
        url:'',
        alt:'2024 ',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Glitz-Media.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Heakth+and+me_+14+Oct+2024_+News+story.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Healthandme_+23+Oct+2024_+News+story.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Health-Shots.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Hindi.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Indian-Mentor.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Mumbai-News-Express.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Navbharat+Time_+14+Oct+2024_+News_+Whatsapp.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Navbharat+Time_+14+Oct+2024_+News+story.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/News+18+_+17+August.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/News+post+_+JAGRAN+JUNCTION_30th+Dec'24.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/News+Post_22+June+2024.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/News+Post_Dainik+Bhaskar+_Mumbai.jpg`,
        url:'',
        alt:'2024',
      },
      // {
      //   img:`https://nispand.s3.ap-south-1.amazonaws.com/files/News+Post_Dainik+Bhaskar+_Mumbai_.jpg`,
      //   url:'',
      //   alt:'2024',
      // },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/News+Post_Dainik+Pudhari_+My+Thane_22+June+2024.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/News+Post_Dainik+Pudhari_Mumbai_22+June+2024.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/News+Stories_Times+of+India_22+June+2024.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/News+Story+_+5th+August+_+Kali+Haldi.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/News+Story+_+JAGRAN+JUNCTION_30th+Dec'24.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/News+Story+_+TGN.jpg`,
        url:'',
        alt:'2024',
      }, 
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/News+Story_+19+June_Dainik+Jagran.jpg`,
        url:'',
        alt:'2024',
      }, 
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/News+Story_3+Sept_+Englsih+Jagran.jpg`,
        url:'',
        alt:'2024',
      }, 
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/News+Story_4+Sept_+Health+Shot.jpg`,
        url:'',
        alt:'2024',
      },
      {
        img: `https://nispand.s3.ap-south-1.amazonaws.com/files/News+Story_Daily+Hunt.jpg`,
        url:'',
        alt:'NBT-2024'
      },
      {
        img: `https://nispand.s3.ap-south-1.amazonaws.com/files/News+Story_Mediabrief.jpg`,
        url:'',
        alt:'2024'
      },
      {
        img: `https://nispand.s3.ap-south-1.amazonaws.com/files/News_+healthandme.jpg`,
        url:'',
        alt:'2024'
      },
      {
        img: `https://nispand.s3.ap-south-1.amazonaws.com/files/Social-News-XYZ.jpg`,
        url:'',
        alt:'2024'
      },
      {
        img: `https://nispand.s3.ap-south-1.amazonaws.com/files/Story_DD+News_16+August.jpg`,
        url:'',
        alt:'2024'
      },
      {
        img: `https://nispand.s3.ap-south-1.amazonaws.com/files/Times+Entertaiment_+21+Oct+2024_+News+story.jpg`,
        url:'',
        alt:'2024'
      },
      {
        img: `https://nispand.s3.ap-south-1.amazonaws.com/files/Times-Entertainment.jpg`,
        url:'',
        alt:'2024'
      },
      {
        img: `https://nispand.s3.ap-south-1.amazonaws.com/files/Times-of-India-April-29.jpg`,
        url:'',
        alt:'2024'
      },
      {
        img: `https://nispand.s3.ap-south-1.amazonaws.com/files/TOI_+22+Oct+2024_+News+story.jpg`,
        url:'',
        alt:'2024'
      },
      {
        img: `https://nispand.s3.ap-south-1.amazonaws.com/files/Trending-Now.jpg`,
        url:'',
        alt:'2024'
      },
      
      
    ]
  },
  {
    year:'2025',
    media:[
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Aaj+Tak-21st+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Bollywood+-+21st+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Bollywood+Now+-+21st+June+2025.jpg`,
        url: '',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Dainik+Bhaskar+-+30th+Jan+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/DC+-+21st+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/DD+Sahyadri+-+9th+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Edvvibes+-+23rd+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Free+Press+Journal++21st+June+2025.jpg`,
        url:'',
        alt:'2024 ',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Konexio+-++23rd+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Media+Catalyst+-+25th+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Navbharat+times+-+21st+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/News+18+-+21st+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/News18+lokmat+-+21st+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/NT+Media+-23rd+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Passionate+-+22nd+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/SME+Street+-+23rd+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Social+News+XYZ+-+22nd+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/The+Economic+Times+-+22nd+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/The+Indian+Express+-+21st+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/The+Times+of+India+-+8th+Feb+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/The+Times+of+India.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/The+Times+of+India_+8th+may+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/The+Times+of+India_+16th+Jan+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Time+Maharashtra+-+21st+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/times+now.jpg`,
        url:'',
        alt:'2025',
      },
      {
        img:`https://nispand.s3.ap-south-1.amazonaws.com/files/Times+of++India+-+21st+June+2025.jpg`,
        url:'',
        alt:'2025',
      },
      
      
    ]
  }
]


export default printMedia
